import PropTypes from 'prop-types';

const SVG = ({
  style = {
    fill: '#000000',
  },
}) => (
  <svg style={style} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51.06 56.01">
    <path d="M44.15 10.01h-.44l.56.45zM8.38 8.86c-.06.17-.11.35-.16.51.26-.16.53-.33.81-.48zm0 0c-.06.17-.11.35-.16.51.26-.16.53-.33.81-.48zm0 0c-.06.17-.11.35-.16.51.26-.16.53-.33.81-.48zm35.77 1.15h-.44l.56.45zM8.38 8.86c-.06.17-.11.35-.16.51.26-.16.53-.33.81-.48zm0 0c-.06.17-.11.35-.16.51.26-.16.53-.33.81-.48zm35.77 1.15h-.44l.56.45zM8.38 8.86c-.06.17-.11.35-.16.51.26-.16.53-.33.81-.48zm35.77 1.15h-.44l.56.45z" />
    <path d="M46.8 10.09a16.73 16.73 0 00-3.45-2.65c-.31-.17-.62-.34-.94-.5a17.74 17.74 0 00-7.88-1.82h-8V1.01a1 1 0 00-2 0v4.11h-8a17.81 17.81 0 00-7.45 1.62l-.44.2a17.37 17.37 0 00-2.92 1.84A14.47 14.47 0 000 20.17a13.07 13.07 0 00.15 2H3.9v.1c0 18.64 9.93 33.74 22.19 33.74s22.2-15.11 22.2-33.75v-.1h2.62a13.07 13.07 0 00.15-2 14.24 14.24 0 00-4.26-10.07zm-1 12.46c0 17.11-8.81 31-19.7 31s-19.69-13.88-19.69-31v-.38h39.38zm3.06-2.38H2.21a1.09 1.09 0 010-.18 12.23 12.23 0 012.66-7.57 13.83 13.83 0 013.36-3.05c.05-.16.1-.34.16-.51h.65a15.35 15.35 0 017.52-2h17.97a15.15 15.15 0 019.19 3h.44l.12.43a12.86 12.86 0 013.49 4.72 12 12 0 011.09 5 1.09 1.09 0 01-.01.16z" />
  </svg>
);

SVG.propTypes = {
  style: PropTypes.object.isRequired,
};

export default SVG;
